
import Icon from '@material-ui/icons/Repeat';
import List from './RecertificateList'
import Create from './RecertificateCreate'
import Edit from './RecertificateEdit'
import Show from './RecertificateVew'


export default {
    list: List,
    icon: Icon,
    create: Create,
    edit: Edit,
    show: Show
};

